import React, {
  useState,
  useContext,
  useEffect,
  useInsertionEffect,
} from "react";
import { Link } from "react-router-dom";
import HelpBar from "../../Components/WeGroup/HelpBar/Index";
import SocialMedia from "../../Components/WeGroup/SocialMedia/Index";
import { FiLogOut } from "react-icons/fi";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import AuthAction from "../../Actions/auth.service";
import {
  hideLoader,
  ShowImage,
  showLoader,
  haveValue,
} from "../../utils/helpers";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AiFillQuestionCircle, AiFillCheckCircle } from "react-icons/ai";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import app, { auth } from "../../../src/firbase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  onAuthStateChanged,
  getAuth,
} from "firebase/auth";

const ProfileMain = (props) => {
  const navigate = useNavigate();

  const {
    isLoggedIn,
    setIsLoggedIn,
    setIsSidebarVisible,
    emailVerified,
    setEmailVerified,
  } = useContext(AuthContext);
  const [myUserInfo, setMyUserInfo] = useState([]);
  const [userExistsFirebase, setUserExistsFirebase] = useState(false);
  const [verifyshow, EmailverifysetShow] = useState(false);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      console.log("Auth state changed:", firebaseUser);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (haveValue(isLoggedIn) && isLoggedIn) {
      AuthAction.getUserData()
        .then((res) => {
          setMyUserInfo(res);
        })
        .catch((err) => {
          console.log(err);
          if (err?.response?.data?.message == "Unauthorized User.") {
            localStorage.removeItem("token");
            setIsLoggedIn(false);
            setIsSidebarVisible(false);
            navigate("/");
          }
        });
    }
  }, [isLoggedIn]);

  useEffect(() => {
    checkIfEmailVerified();
  }, [myUserInfo]);

  useEffect(() => {
    checkIfEmailVerified();
  }, [verifyshow]);

  // useEffect(() => {
  //   setEmailVerified(emailVerified);
  // }, [emailVerified]);

  setTimeout(() => {
    console.log("checking...");
    checkIfEmailVerified();
  }, 5000);

  const verifyEmailClose = () => EmailverifysetShow(false);

  const checkIfEmailVerified = async () => {
    const email = myUserInfo?.email?.trim().toLowerCase();
    if (!email) return;
    if (auth.currentUser) {
      await auth.currentUser.reload();
      const verified = auth.currentUser.emailVerified;
      setEmailVerified(verified);
    }
    // else {
    //   signInWithEmailAndPassword(auth, email, "password")
    //     .then((userCredential) => {
    //       const user = userCredential.user;
    //       console.log("Email Verified:", user.emailVerified);
    //       setEmailVerified(user.emailVerified);
    //     })
    //     .catch((err) => {
    //       console.error("Sign-in error:", err.message);
    //       // setEmailVerified(false);
    //     });
    // }
  };

  const verifyEmail = async () => {
    showLoader();
    try {
      // First try signing in
      const userCredential = await signInWithEmailAndPassword(
        auth,
        myUserInfo?.email,
        "password"
      );

      if (!userCredential.user.emailVerified) {
        await sendEmailVerification(userCredential.user);
        console.log("Verification email sent");
      }

      // await auth.signOut();
      EmailverifysetShow(true);
    } catch (err) {
      if (
        err.code === "auth/user-not-found" ||
        err.code === "auth/invalid-login-credentials"
      ) {
        // If user doesn't exist yet, create them
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          myUserInfo?.email,
          "password"
        );
        await sendEmailVerification(userCredential.user);
        // await auth.signOut();
        EmailverifysetShow(true);
      } else {
        console.error("Email verification error:", err.message);
      }
    } finally {
      hideLoader();
    }
  };

  const resendEmail = async () => {
    showLoader();
    signInWithEmailAndPassword(auth, myUserInfo?.email, "password").then(
      (userCredential) => {
        sendEmailVerification(auth.currentUser)
          .then((res) => {
            // auth.signOut();
            EmailverifysetShow(true);
            hideLoader();
          })
          .catch(alert);
        auth.signOut();
      }
    );
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("backToRecList");
    setIsLoggedIn(false);
    setIsSidebarVisible(false);

    navigate("/");
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Email is not verified.
    </Tooltip>
  );

  const handleNavigateConnections = () => {
    navigate("/myConnections");
  };
  return (
    <>
      <div className="profile-tophead">
        <h4 className="titleevent">Profile</h4>
        <div className="uploadmedia">
          <div className="avatar-img">
            <img
              src={ShowImage(myUserInfo?.profilePhoto, myUserInfo?.fullName)}
              alt="img"
            />
          </div>
        </div>
        <div className="userinfo-bar">
          <h4>{myUserInfo?.fullName}</h4>
          {myUserInfo?.phoneNumber ? <p>{myUserInfo?.phoneNumber}</p> : ""}
          {myUserInfo?.email ? (
            <p className="email-verify">
              {myUserInfo?.email}
              {emailVerified ? (
                <>
                  <Button
                    className="verify-btn verified-btn"
                    style={{ cursor: "pointer" }}
                  >
                    <AiFillCheckCircle />
                  </Button>
                </>
              ) : (
                <>
                  {" "}
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                  >
                    <div className="verifybar">
                      {userExistsFirebase ? (
                        <>
                          {" "}
                          <Button className="verify-btn" onClick={resendEmail}>
                            <AiFillQuestionCircle />
                          </Button>
                        </>
                      ) : (
                        <>
                          {" "}
                          <Button className="verify-btn" onClick={verifyEmail}>
                            <AiFillQuestionCircle />
                          </Button>
                        </>
                      )}
                      <Modal
                        className="Createevent-modal fixamountpopup "
                        show={verifyshow}
                        onHide={verifyEmailClose}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Email Verification</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Email has been sent.</Modal.Body>
                        <Modal.Footer>
                          {/* <Button
                            className="btn-pink"
                            onClick={verifyEmailClose}
                          >
                            Close
                          </Button> */}
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </OverlayTrigger>
                </>
              )}
            </p>
          ) : (
            ""
          )}
          <div
            className="d-flex justify-content-between cursor-pointer"
            onClick={handleNavigateConnections}
          >
            <p className="red-color connections_text">My Connections</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
            >
              <path
                d="M1.66667 6H15M15 6L10 11M15 6L10 1"
                stroke="#E31B54"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="eventbar">
        <Link to="/editprofile" type="button" className="btngray">
          Edit Profile
        </Link>
        <Link
          to="/eventstep1"
          onClick={() => localStorage.setItem("soloGift", false)}
          className="btn-pink mt-3"
        >
          Create a Event
        </Link>
        {/* <Link
          to="/eventstep1"
          onClick={() => localStorage.setItem("soloGift", true)}
          className="btn-pink mt-3"
        >
          Create a Solo Event
        </Link> */}
        {isLoggedIn ? (
          <Link to="/recipientlist" className="btn_outline mt-3">
            Gifts Received
          </Link>
        ) : (
          ""
        )}
      </div>
      {/* <HelpBar /> */}
      <SocialMedia />
      <div className="btnlogout">
        <button onClick={logout} type="button" className="btn-pink">
          <FiLogOut />
          Logout
        </button>
      </div>
    </>
  );
};

export default ProfileMain;
